import { render, staticRenderFns } from "./CertificationReports.vue?vue&type=template&id=34678b70"
import script from "./CertificationReports.vue?vue&type=script&lang=js"
export * from "./CertificationReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports